import css from 'styled-jsx/css';

const styles = css.global`.desktop {
    display: none;
}

#banco-do-auto-moto .container-moto {
    display: flex;
    flex-direction: column;
}

#banco-do-auto-moto .moto-title {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    margin: 0;
}

#banco-do-auto-moto .moto-title b {
    color: #C00;
    font-weight: 800;
}

#banco-do-auto-moto .moto-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 32px;
    margin-top: 16px;
    max-width: 560px;
}

#banco-do-auto-moto .moto-paragrafo b {
    font-weight: 600;
}

#banco-do-auto-moto .btn-banco-do-auto-moto {
    width: 100%;
    height: 48px;
    margin-bottom: 48px;
}

#banco-do-auto-moto .banco-do-auto-imagem {
    width: 100%;
    max-width: 350px;
    margin-top: 48px;
    margin-bottom: 16px;
}

#banco-do-auto-moto .container-moto {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

@media(min-width: 992px) {
    #banco-do-auto-moto .moto-title {
        max-width: unset;
        font-size: 34px;
    }

    #banco-do-auto-moto {
        height: 409px;
        display: flex;
    }

    #banco-do-auto-moto .container-moto {
        flex-direction: row;
    }

    #banco-do-auto-moto .link-banco-do-auto-moto {
        color: #C00;
        font-family: "SantanderText";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        width: 272px;
    }

    #banco-do-auto-moto .link-regulamento {
        color: #C00;
        font-family: "SantanderText";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        display: flex;
        align-items: center;
        margin-bottom: 24px;
    }

    #banco-do-auto-moto .link-regulamento img {
        margin-right: 8px;
    }
}`;

export default styles;